/**
 * Figma list row with a chevron (05b, 06, E1): 42 px full-width hotspot, Signika Medium 15 #49454f
 * at 20 px, violet 24 px chevron 20 px from the right, 1 px divider (inset 20 px) at the bottom.
 * Meant for a `sheet` (20 px side padding), which it bleeds out of.
 */
export function ListRow(props: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      class="-mx-5 block w-[calc(100%+40px)] px-5 text-left active:bg-surface2"
      onClick={props.onClick}
    >
      <span class="flex h-[42px] items-center justify-between border-b border-border text-[15px] font-medium leading-[1.25] tracking-[0.15px] text-strong">
        {props.label}
        <img src="/icons/chevron-right.svg" width="24" height="24" alt="" />
      </span>
    </button>
  );
}
